import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class AuditEventLogService extends Service{
    constructor() {
        super();
        this.baseURL = 'auditEventLog';
    }

    findByAuditEventId(auditEventId) {
        return fetch(SERVER_URL + this.baseURL + '/findByAuditEventId/' + auditEventId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}